var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12ZM14 9C14 9.53043 13.7893 10.0391 13.4142 10.4142C13.0391 10.7893 12.5304 11 12 11C11.4696 11 10.9609 10.7893 10.5858 10.4142C10.2107 10.0391 10 9.53043 10 9C10 8.46957 10.2107 7.96086 10.5858 7.58579C10.9609 7.21071 11.4696 7 12 7C12.5304 7 13.0391 7.21071 13.4142 7.58579C13.7893 7.96086 14 8.46957 14 9ZM12 13C11.0426 12.9998 10.1053 13.2745 9.29942 13.7914C8.49356 14.3083 7.85304 15.0457 7.454 15.916C8.01668 16.5706 8.71427 17.0958 9.49894 17.4555C10.2836 17.8152 11.1368 18.0009 12 18C12.8632 18.0009 13.7164 17.8152 14.5011 17.4555C15.2857 17.0958 15.9833 16.5706 16.546 15.916C16.147 15.0457 15.5064 14.3083 14.7006 13.7914C13.8947 13.2745 12.9574 12.9998 12 13Z",
    fill: "#B0BABF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDisabled);
export default __webpack_public_path__ + "static/media/UserDisabled.20a18bd7e3717639298d219b7597ef91.svg";
export { ForwardRef as ReactComponent };